export default "__VITE_ASSET__D4UQSeFp__"